import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  preventFileAttach(event) {
    event.preventDefault()
  }

  removeFileAttachment(event) {
    event.attachment.remove()
  }
}
